export enum ETestDriveActions {
    SetIsShowDetails = '@test-drive/SetIsShowDetails',
    SetIsShowOptionSelect = '@test-drive/SetIsShowOptionSelect',
}
